export function Menu({menu, handleClick, onglet}) {
  return (
      <ul className="onglet">
        {menu.map((e, k) => <li key={k} name={e} className={"onglet " + (e === onglet ? 'active ' : '') + ('DonnerCréerMes sériesRetrouverLes erreurs'.includes(e) && ' sousmenu')} onClick={handleClick} >{e}</li>)}
      </ul>
  );
}